import type { ConnectionResp, ConnectionStatus } from '../subscriptionConnection.types';
import { ConnectorRespModel } from '@repositories/productConnectorRepository/models/ConnectorRespModel';

export class ConnectionRespModel {
  private readonly _dto: ConnectionResp;
  private readonly _connector: ConnectorRespModel;

  constructor(dto: ConnectionResp) {
    this._dto = dto;
    this._connector = new ConnectorRespModel(dto.connector || {});
  }

  get originDTO(): ConnectionResp {
    return this._dto;
  }

  get callbackUri() {
    return this._dto.callbackUri || '';
  }

  get connectionInfo() {
    return this._dto.connectionInfo || {};
  }

  get connector() {
    return this._connector;
  }

  get connectorId() {
    return this._dto.connectorId || '';
  }

  get context() {
    return this._dto.context || { contextData: '' };
  }

  get id() {
    return this._dto.id || '';
  }

  get name() {
    return this._dto.name || '';
  }

  get status(): ConnectionStatus {
    return this._dto.status || 'DISCONNECTED';
  }

  get statusMessage() {
    return this._dto.statusMessage || '';
  }
}
